/* Marcel Afters, PHASE B (11 Oct 2026): the 2027 layer.
   - Edition chip: "Day edition / After edition"; hover shows local time; click flips the edition live (view transition).
   - Hero films: plays the film of the edition on screen, pauses off-screen, never under reduced motion or data saver.
   - Shop the frame: any [data-ma-frame] photo gets a "Shop the look" button that opens one bottom sheet (popover API) listing the
     pieces in the photo with sizes, Add to bag per piece, and Add the look. Adds reuse assets/ma-look.js (window.MaXsell).
   - Living PDP slot: <template id="ma-living"> (snippets/ma-edition-pdp.liquid) becomes a muted loop over the lead still.
   - Magnetic card hover on fine pointers.
   No dependencies. Everything degrades to the server-rendered Day page without JavaScript. */
(function () {
  if (window.__ma27) return; window.__ma27 = 1;
  var d = document, html = d.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var conn = navigator.connection || {};
  var lite = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  function ed() { return html.getAttribute('data-edition') || 'day'; }
  function onReady(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }

  /* ---------- Edition chip ---------- */
  function clock() {
    try { return new Intl.DateTimeFormat(html.lang || undefined, { hour: 'numeric', minute: '2-digit' }).format(new Date()); }
    catch (e) { var n = new Date(); return n.getHours() + ':' + String(n.getMinutes()).padStart(2, '0'); }
  }
  function paintChip() {
    d.querySelectorAll('[data-ma-ed-chip]').forEach(function (b) {
      var e = ed(), other = e === 'day' ? 'After' : 'Day';
      b.querySelector('.ma-ed-chip__l').textContent = (e === 'day' ? 'Day' : 'After') + ' edition';
      b.querySelector('.ma-ed-chip__tip').innerHTML = 'Your time <b>' + clock() + '</b> &middot; see the ' + other + ' edition';
      b.setAttribute('aria-label', (e === 'day' ? 'Day' : 'After') + ' edition. Your time ' + clock() + '. Switch to the ' + other + ' edition');
    });
  }
  d.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ma-ed-chip]');
    if (!b || !window.MAED) return;
    window.MAED.set(ed() === 'day' ? 'after' : 'day');
  });
  d.addEventListener('ma:edition', function () { paintChip(); films(); });
  onReady(paintChip);
  setInterval(paintChip, 30000);

  /* ---------- Hero films ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { var v = e.target; v.__vis = e.isIntersecting; if (e.isIntersecting) play(v); else v.pause(); });
  }, { threshold: 0.01 }) : null;
  function play(v) {
    if (reduce.matches || lite || d.hidden || v.__vis === false || !v.isConnected) return;
    var mob = matchMedia('(max-width: 749px)').matches, u = mob ? v.dataset.srcM : v.dataset.srcD;
    if (!u) return;
    if (v.__cur !== u) { v.__cur = u; v.classList.remove('is-on'); v.src = u; v.load(); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function films() {
    d.querySelectorAll('video[data-ma-film]').forEach(function (v) {
      if (v.__ma) { play(v); return; }
      v.__ma = 1;
      v.addEventListener('playing', function () { if (!reduce.matches) v.classList.add('is-on'); });
      if (io) io.observe(v);
      var start = function () { play(v); };
      if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 1600 }); else setTimeout(start, 400);
    });
  }
  d.addEventListener('visibilitychange', function () { d.querySelectorAll('video[data-ma-film]').forEach(function (v) { if (d.hidden) v.pause(); else play(v); }); });
  if (d.readyState === 'complete') films(); else addEventListener('load', films);

  /* ---------- Shop the frame ---------- */
  var sheet = null, lastBtn = null;
  var X = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.3" fill="none"/></svg>';
  function fmt(c) { return window.MaXsell ? window.MaXsell.fmt(c) : '$' + Math.round(c / 100); }
  function getSheet() {
    if (sheet) return sheet;
    sheet = d.createElement('div');
    sheet.id = 'ma-sheet'; sheet.className = 'ma-sheet'; sheet.setAttribute('popover', 'auto');
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-labelledby', 'ma-sheet-t');
    sheet.setAttribute('data-mxl', '');
    sheet.innerHTML = '<span class="ma-sheet__grab" aria-hidden="true"></span>' +
      '<div class="ma-sheet__hd"><div><p class="ma-sheet__k" data-ma-sheet-k>In this frame</p><h2 class="ma-sheet__t" id="ma-sheet-t">Shop the look</h2></div>' +
      '<button type="button" class="ma-sheet__x" data-ma-sheet-x aria-label="Close">' + X + '</button></div>' +
      '<div class="ma-sheet__bd"><ul class="mxl__list" role="list" data-ma-sheet-list></ul></div>' +
      '<div class="ma-sheet__ft"><p class="mxl__msg" data-mxl-msg role="status" aria-live="polite"></p>' +
      '<p class="ma-sheet__off" data-ma-sheet-off hidden>Dress the Set savings are taken off in the bag.</p>' +
      '<button type="button" class="ma-sheet__all" data-ma-sheet-all><span data-ma-sheet-lab>Add the look</span><span class="ma-sheet__tot" data-ma-sheet-tot></span></button></div>';
    d.body.appendChild(sheet);
    sheet.addEventListener('toggle', function (e) {
      if (e.newState === 'closed' && lastBtn && lastBtn.isConnected) { try { lastBtn.focus({ preventScroll: true }); } catch (x) {} }
      if (e.newState === 'open') { var f = sheet.querySelector('[data-ma-sheet-x]'); if (f) f.focus({ preventScroll: true }); }
    });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ma-sheet-x]')) sheet.hidePopover();
      var all = e.target.closest('[data-ma-sheet-all]'); if (all) addAll(all);
      if (e.target.closest('.mxl__z')) setTimeout(total, 0);
    });
    return sheet;
  }
  function chosen(item) {
    if (item.dataset.single) return item.dataset.single;
    var p = item.querySelector('.mxl__z[aria-pressed="true"]'); return p ? p.dataset.id : '';
  }
  function total() {
    if (!sheet) return;
    var items = sheet.querySelectorAll('[data-mxl-item]'), sum = 0, n = items.length;
    items.forEach(function (it) { sum += +it.dataset.price || 0; });
    if (sheet.__withMain) { var pr = d.querySelector('[data-mx-price] > span') || d.querySelector('[data-mx-price]'); var main = pr ? Math.round(parseFloat(pr.textContent.replace(/[^0-9.]/g, '')) * 100) : 0; if (main) { sum += main; n++; } }
    sheet.querySelector('[data-ma-sheet-tot]').textContent = n > 1 ? fmt(sum) : '';
    sheet.querySelector('[data-ma-sheet-all]').hidden = n < 2;
  }
  function say(t) { var m = sheet.querySelector('[data-mxl-msg]'); if (m) m.textContent = t || ''; }
  async function addAll(btn) {
    var items = [].slice.call(sheet.querySelectorAll('[data-mxl-item]'));
    var miss = items.filter(function (it) { return !chosen(it); });
    if (miss.length) {
      miss.forEach(function (it) { it.classList.add('is-prompt'); setTimeout(function () { it.classList.remove('is-prompt'); }, 1400); });
      say('Choose a size for ' + miss.map(function (it) { return it.dataset.title; }).join(' and ') + '.');
      var f = miss[0].querySelector('.mxl__z:not([disabled])'); if (f) { f.focus({ preventScroll: true }); try { miss[0].scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (x) {} }
      return;
    }
    if (!window.MaXsell) { say('Could not reach the bag. Try again.'); return; }
    var lines = items.map(function (it) { return { id: chosen(it), quantity: 1 }; });
    if (sheet.__withMain) {
      var idIn = d.querySelector('[data-mx-id]'), fs = d.querySelector('[data-mx-size]');
      var parts = fs ? [].slice.call(fs.querySelectorAll('[data-mx-part]')) : [];
      var sized = !fs || (parts.length ? parts.every(function (p) { return p.querySelector('input:checked'); }) : !!fs.querySelector('input:checked'));
      if (!idIn || !sized) {
        say('Choose your size for this piece on the page first.');
        setTimeout(function () { sheet.hidePopover(); if (fs) { fs.classList.add('is-prompt'); try { fs.scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (x) {} setTimeout(function () { fs.classList.remove('is-prompt'); }, 1600); } }, 900);
        return;
      }
      lines.unshift({ id: idIn.value, quantity: 1 });
    }
    btn.setAttribute('aria-busy', 'true'); say('');
    var r = await window.MaXsell.addLines(btn, lines);
    btn.removeAttribute('aria-busy');
    if (r.ok) {
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'add_to_cart', source: 'shop_the_frame', items: lines.map(function (l) { return { item_id: String(l.id), quantity: 1 }; }) }); } catch (x) {}
      btn.classList.add('is-added'); btn.querySelector('[data-ma-sheet-lab]').textContent = 'Added';
      setTimeout(function () { btn.classList.remove('is-added'); btn.querySelector('[data-ma-sheet-lab]').textContent = 'Add the look'; }, 2200);
      if (!r.events) location.href = ((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart');
      else if (sheet.matches(':popover-open')) sheet.hidePopover();
    } else say((r.json && (r.json.description || r.json.message)) || 'Could not add the look. Try again.');
  }
  function rowsFor(btn) {
    var key = btn.getAttribute('data-ma-frame-open'), tpl = key && d.querySelector('template[data-ma-frame-rows="' + key + '"]');
    if (tpl) return tpl.content.cloneNode(true);
    /* PDP fallback: this piece plus the Complete the look rows already on the page */
    var frag = d.createDocumentFragment();
    d.querySelectorAll('.mxl--pdp [data-mxl-item]').forEach(function (it, i) {
      if (i < 2) { var c = it.cloneNode(true); c.querySelectorAll('[aria-pressed="true"]').forEach(function (z) { z.setAttribute('aria-pressed', 'false'); }); frag.appendChild(c); }
    });
    return frag;
  }
  function openFrame(btn) {
    var s = getSheet(), list = s.querySelector('[data-ma-sheet-list]');
    list.textContent = '';
    list.appendChild(rowsFor(btn));
    list.querySelectorAll('[data-mxl-item]').forEach(function (it, i) { it.style.setProperty('--i', i); it.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); });
    var n = list.querySelectorAll('[data-mxl-item]').length, framed = !!btn.getAttribute('data-ma-frame-open');
    s.querySelector('[data-ma-sheet-k]').textContent = framed ? (n > 1 ? n + ' pieces in this frame' : 'In this frame') : 'Wear it with';
    s.querySelector('#ma-sheet-t').textContent = framed ? (n > 1 ? 'Shop the look' : 'Shop this piece') : 'Complete the look';
    s.__withMain = !framed && !!d.querySelector('[data-mx-id]');
    var off = s.querySelector('[data-ma-sheet-off]'); if (off) off.hidden = !d.querySelector('[data-ma-dts]');
    say(''); total();
    lastBtn = btn;
    try { s.showPopover({ source: btn }); } catch (e) { try { s.showPopover(); } catch (e2) {} }
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ma-frame-open]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    openFrame(b);
  }, true);

  /* PDP: put a Shop the look button on the lead photo (model at #1, D13) */
  function pdpFrame() {
    var self = d.querySelector('template[data-ma-frame-self]'), slide = d.querySelector('[data-mx-gal] .mx-pdp__slide');
    if (!self || !slide || slide.querySelector('[data-ma-frame-open]')) return;
    var extra = d.querySelectorAll('.mxl--pdp [data-mxl-item]').length, hasTpl = d.querySelector('template[data-ma-frame-rows="pdp"]');
    var n = hasTpl ? hasTpl.content.querySelectorAll('[data-mxl-item]').length : 1 + Math.min(2, extra);
    if (n < 2 || (!hasTpl && extra < 1)) return;
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'ma-frame-btn'; b.setAttribute('data-ma-frame-open', hasTpl ? 'pdp' : '');
    var lab = hasTpl ? 'Shop the look' : 'Complete the look';
    b.setAttribute('aria-label', lab + ': ' + n + ' pieces');
    b.innerHTML = '<span class="ma-frame-btn__plus" aria-hidden="true"></span><span class="ma-frame-btn__t">' + lab + '</span><span class="ma-frame-btn__n" aria-hidden="true">' + n + '</span>';
    slide.appendChild(b);
  }

  /* ---------- Living PDP slot ---------- */
  function living() {
    var t = d.getElementById('ma-living');
    if (!t || reduce.matches || lite) return;
    var id = t.dataset.media, slide = (id && d.querySelector('[data-mx-gal] .mx-pdp__slide[data-media-id="' + id + '"]')) || d.querySelector('[data-mx-gal] .mx-pdp__slide');
    if (!slide || slide.querySelector('.ma-living')) return;
    var frag = t.content.cloneNode(true), v = frag.querySelector('video'), img = slide.querySelector('img');
    if (!v) return;
    if (img && img.currentSrc) v.poster = img.currentSrc;
    slide.appendChild(frag);
    v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
    if (io) { v.__vis = true; io.observe(v); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  /* ---------- Magnetic cards ---------- */
  function magnet() {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches || reduce.matches) return;
    var sel = 'main :is(.mx-card, product-card, .product-card, .ma-gt__link)';
    d.addEventListener('pointerover', function (e) {
      var c = e.target.closest && e.target.closest(sel); if (!c || c.__mag) return;
      c.__mag = 1; c.classList.add('ma-mag');
      c.addEventListener('pointermove', function (ev) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--mx', ((ev.clientX - r.left) / r.width - .5).toFixed(3));
        c.style.setProperty('--my', ((ev.clientY - r.top) / r.height - .5).toFixed(3));
      });
      c.addEventListener('pointerenter', function () { c.classList.add('is-hot'); });
      c.addEventListener('pointerleave', function () { c.classList.remove('is-hot'); c.style.setProperty('--mx', 0); c.style.setProperty('--my', 0); });
      c.classList.add('is-hot');
    });
  }


  /* ---------- Estimated arrival (shop metafield custom.delivery_window_days) ---------- */
  function addBiz(n) {
    var d = new Date(); d.setHours(12, 0, 0, 0); var k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
    return d;
  }
  function etaText(min, max) {
    var o = { weekday: 'short', day: 'numeric', month: 'short' }, f;
    try { f = new Intl.DateTimeFormat(html.lang || undefined, o); } catch (e) { f = { format: function (x) { return x.toDateString().slice(0, 10); } }; }
    return f.format(addBiz(min)) + ' \u2013 ' + f.format(addBiz(max));
  }
  /* DELIVERY PROMISE (14 Oct 2026): the short dated range for the PDP first screen, "Arrives Oct 21\u201327", from the same business-day window and the same
     weekend-skipping as the Estimated arrival lines (snippets/ma-arrives.liquid prints the window). Same month: "Oct 21\u201327"; across months: "Oct 28 \u2013 Nov 3". */
  function arrivesText(min, max) {
    var a = addBiz(min), b = addBiz(max), f, g;
    try { f = new Intl.DateTimeFormat(html.lang || undefined, { month: 'short', day: 'numeric' }); g = new Intl.DateTimeFormat(html.lang || undefined, { day: 'numeric' }); } catch (e) { return ''; }
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) return f.format(a) + '\u2013' + g.format(b);
    return f.format(a) + ' \u2013 ' + f.format(b);
  }
  function arrives() {
    d.querySelectorAll('[data-ma-arrives]').forEach(function (p) {
      var t = p.querySelector('[data-ma-arrives-d]'); if (!t || t.__done) return; t.__done = 1;
      var txt = arrivesText(+p.dataset.min, +p.dataset.max); if (txt) t.textContent = 'Arrives ' + txt;
    });
  }
  function etaPdp() {
    arrives();
    d.querySelectorAll('[data-ma-eta27]').forEach(function (p) {
      var t = p.querySelector('[data-ma-eta27-d]'); if (!t || t.__done) return; t.__done = 1;
      t.textContent = etaText(+p.dataset.min, +p.dataset.max);
    });
  }
  function etaBag() {
    var m = d.querySelector('meta[name="ma-eta"]'); if (!m) return;
    var mm = m.content.split(','), min = +mm[0], max = +mm[1]; if (!min || !max) return;
    d.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      var sum = btn.parentElement; if (!sum || sum.parentElement.querySelector('.ma-eta27--bag')) return;
      var el = d.createElement('p'); el.className = 'ma-eta27 ma-eta27--bag';
      el.innerHTML = '<span class="ma-eta27__k">Estimated arrival</span> <span class="ma-eta27__d"></span><span class="ma-eta27__n">US Express, free. Estimate, not guaranteed.</span>';
      el.querySelector('.ma-eta27__d').textContent = etaText(min, max);
      sum.insertBefore(el, btn);
    });
  }
  onReady(function () { etaPdp(); etaBag(); });
  if (window.MutationObserver) {
    var etaT; new MutationObserver(function () { clearTimeout(etaT); etaT = setTimeout(etaBag, 60); }).observe(d.documentElement, { childList: true, subtree: true });
  }

  /* the bag drawer overlays the page with a scrim (ma-lock.css section 12); a click on the scrim closes it */
  d.addEventListener('click', function (e) {
    var w = d.querySelector('.page-wrapper--drawer-open');
    if (!w || e.target !== w) return;
    var td = d.querySelector('theme-drawer[open]');
    if (td && typeof td.close === 'function') td.close();
    else { var b = d.querySelector('.theme-drawer__dialog[open] .theme-drawer__close-button'); if (b) b.click(); }
  });
  onReady(function () { pdpFrame(); magnet(); });
  if (d.readyState === 'complete') living(); else addEventListener('load', function () { setTimeout(living, 300); });
})();
